module.exports = __webpack_public_path__ + "img/preview_unit.bdd2724d.png";